/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A heading for an evaluable fact.
 */
export interface AnalyticMeasureType { 
    /**
     * Internal AnalyticMeasureType Key
     */
    id?: number;
    title?: string;
    /**
     * Flag to indicate if the evaluable fact is visible
     */
    isVisible?: number;
    /**
     * Position of the column in the order of table column sorting
     */
    sort?: number;
    /**
     * Number of decimal places for specific number value field
     */
    decimals?: number;
    /**
     * Template for formatting of values
     */
    formatstring?: string;
    /**
     * Title of the evaluable fact column
     */
    description?: string;
}

